(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (factory());
}(this, (function () { 'use strict';

    (function () {

        // Smooth Scroll
        //--------------------------------------------------
        var hashLinks = document.querySelectorAll('a[href^="#"]');

        var _loop = function _loop(_i) {
            hashLinks[_i].addEventListener('click', function (e) {
                e.preventDefault();
                var hash = hashLinks[_i].hash;
                hash = hash.slice(1);
                var target = document.getElementById(hash);
                var elemY = target.getBoundingClientRect().top;
                var scrollY = window.pageYOffset;
                var top = Math.ceil(elemY + scrollY);
                window.scroll({
                    top: top,
                    behavior: 'smooth'
                });
            });
        };

        for (var _i = 0; _i < hashLinks.length; _i++) {
            _loop(_i);
        }

        // よくある質問
        //--------------------------------------------------
//         var coll = document.getElementsByClassName("qatoggle");
//         for (var i = 0; i < document.getElementsByClassName("qatoggle").length; i++) {
//             coll[i].addEventListener("click", function () {
//               	this.classList.toggle("active");
//                 var content = this.nextElementSibling;
//                 if (content.style.maxHeight) {
//                     content.style.maxHeight = null;
//                 } else {
//                     content.style.maxHeight = content.scrollHeight + "px";
//                 }
//             });
//         }
    })();

})));

$(function(){
  // よくある質問
  $(".qatoggle").on("click", function() {
    $(this).toggleClass("active");
    var content = this.nextElementSibling;
    if (content.style.maxHeight) {
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    }    
  });
  
  $('.p-lp a').attr('target' , '_blank');
});
